import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const RejectionReasons = () => {
  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Name' },
    { key: 'category', label: 'Category' },
    { key: 'description', label: 'Description' },
    { key: 'is_active', label: 'Status' },
  ];

  const formFields = [
    { name: 'code', label: 'Code', required: true, placeholder: 'REJ001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Rejection Reason' },
    { 
      name: 'category', 
      label: 'Category', 
      type: 'select',
      options: [
        { value: 'PROCESS', label: 'Process' },
        { value: 'MATERIAL', label: 'Material' },
        { value: 'MACHINE', label: 'Machine' },
        { value: 'OPERATOR', label: 'Operator' },
      ]
    },
    { name: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { name: 'is_active', label: 'Status', type: 'boolean', defaultValue: true },
  ];

  return (
    <MasterLayout
      title="Rejection Reasons"
      endpoint="rejection-reasons"
      columns={columns}
      formFields={formFields}
      permissions={['ADMIN', 'QUALITY']}
    />
  );
};

export default RejectionReasons;
